export default __webpack_public_path__ + "static/media/h3-1.2b620504.jpg";